import { STEP_KEY } from './utils';

// Step components
import LocationComponent from './components/Location/Location';
import WelcomeComponent from './components/Welcome/Welcome';
import AttitudeComponent from './components/Attitude/Attitude';
import GoalsComponent from './components/Goals/Goals';
import ReasonComponent from './components/Reason/Reason';
import ReasonDetailsComponent from './components/ReasonDetails/ReasonDetails';
import SpecialistTypeComponent from './components/SpecialistType/SpecialistType';
import SpecialistReferralComponent from './components/SpecialistReferral/SpecialistReferral';
import CriteriaComponent from './components/Criteria/Criteria';
import LastVisitedComponent from './components/LastVisited/LastVisited';
import AnxietyComponent from './components/Anxiety/Anxiety';
import AvailabilityComponent from './components/Availability/Availability';
import HowSoonComponent from './components/HowSoon/HowSoon';
import InsuranceComponent from './components/Insurance/Insurance';
import GenderComponent from './components/Gender/Gender';
import ContactComponent from './components/Contact/Contact';
import SearchComponent from './components/Search/Search';
import ExistingAnswersComponent from './components/ExistingAnswers/ExistingAnswers';
import ExistingMatchComponent from './components/ExistingMatch/ExistingMatch';
import OngoingCareComponent from './components/OngoingCare/OngoingCare';
import ConcernsTreatmentComponent from './components/ConcernsTreatment/ConcernsTreatment';

// Step objects
export const FUNNEL_STEPS = {
  Welcome: {
    name: STEP_KEY.WELCOME,
    path: 'welcome',
    component: WelcomeComponent,
  },

  Location: {
    name: STEP_KEY.LOCATION,
    path: 'location',
    component: LocationComponent,
  },

  Reason: {
    name: STEP_KEY.REASON,
    path: 'reason',
    component: ReasonComponent,
  },

  ReasonDetails: {
    name: STEP_KEY.REASON_DETAILS,
    path: 'reason-details',
    component: ReasonDetailsComponent,
  },

  SpecialistType: {
    name: STEP_KEY.SPECIALIST_TYPE,
    path: 'specialist-type',
    component: SpecialistTypeComponent,
  },

  SpecialistReferral: {
    name: STEP_KEY.SPECIALIST_REFERRAL,
    path: 'specialist-referral',
    component: SpecialistReferralComponent,
  },

  Attitude: {
    name: STEP_KEY.ATTITUDE,
    path: 'attitude',
    component: AttitudeComponent,
  },

  Goals: {
    name: STEP_KEY.GOALS,
    path: 'goals',
    component: GoalsComponent,
  },

  Criteria: {
    name: STEP_KEY.CRITERIA,
    path: 'criteria',
    component: CriteriaComponent,
  },

  LastVisited: {
    name: STEP_KEY.LAST_VISITED,
    path: 'last-visited',
    component: LastVisitedComponent,
  },

  Anxiety: {
    name: STEP_KEY.ANXIETY,
    path: 'anxiety',
    component: AnxietyComponent,
  },

  Availability: {
    name: STEP_KEY.AVAILABILITY,
    path: 'availability',
    component: AvailabilityComponent,
  },

  HowSoon: {
    name: STEP_KEY.HOW_SOON,
    path: 'how-soon',
    component: HowSoonComponent,
  },

  Insurance: {
    name: STEP_KEY.INSURANCE,
    path: 'insurance',
    component: InsuranceComponent,
  },

  Gender: {
    name: STEP_KEY.GENDER,
    path: 'gender',
    component: GenderComponent,
  },

  Contact: {
    name: STEP_KEY.CONTACT,
    path: 'email',
    component: ContactComponent,
  },

  Search: {
    name: 'search',
    path: 'search',
    component: SearchComponent,
  },

  ExistingAnswers: {
    name: 'existing-answers',
    path: 'existing-search',
    component: ExistingAnswersComponent,
  },

  ExistingMatch: {
    name: 'existing-match',
    path: 'existing-match',
    component: ExistingMatchComponent,
  },

  OngoingCare: {
    name: STEP_KEY.ONGOING_CARE,
    path: 'ongoing-care',
    component: OngoingCareComponent,
  },

  ConcernsTreatment: {
    name: STEP_KEY.CONCERNS_TREATMENT,
    path: 'concerns-treatment',
    component: ConcernsTreatmentComponent,
  },
};
